export default "__VITE_ASSET__DUcLn3sH__"